<div class="register-page   mb-5">
    <div class="zoom-wrapper">
        <div class="container">
            <app-breadcrumb [breadcrumbs]="currentBreadcrumb"></app-breadcrumb>
            <div class="register-page-top">
                <div class="d-flex justify-content-center register-content flex-column align-items-center">
                    <div class="d-flex flex-column justify-content-center a-customer align-items-center">
                        <h3 class="mb-3">Already a customer ?</h3>
                        <a href="javascript:void" routerLink="/activate-account"> Activate your account</a>
                    </div>
                    <h5>Please Fill Out this Form To Register</h5>
                </div>
                <div class="download d-flex justify-content-center align-items-center">
                    <img class="form-img" src="/images/svg/pdf.svg" alt="">
                    <p>Register Form</p>
                    <div>
                        <a href="images/Application.pdf" class="me-2" download="Register-Form">Download <span><img
                                    src="/images/svg/view.svg" alt=""></span></a>
                    </div>
                </div>
                <!-- <form>
                    <div class="form-group">
                        <label for="costumerNumber">Business Name</label>
                        <input name="name" [(ngModel)]="register.companyName" type="text" class="form-input">
                    </div>
                      <div class="form-group">
                          <label for="firstName">First Name</label>
                          <input name="firstName" [(ngModel)]="register.firstName" type="text" class="form-input">
                      </div>
                      <div class="form-group">
                          <label for="lastName">Last Name</label>
                          <input name="lastName" [(ngModel)]="register.lastName" type="text" class="form-input">
                      </div>
                      <div class="form-group">
                        <label for="email">Email</label>
                        <input name="email" [(ngModel)]="register.email" type="email" class="form-input">
                    </div>
                    <div class="form-group">
                        <label for="costumerNumber">Phone Number</label>
                        <input name="phoneNumber" [(ngModel)]="register.phoneNumber" type="text" class="form-input">
                    </div>
                    <div class="form-group">
                        <label for="password">Password</label>
                        <input name="password" [(ngModel)]="register.password" type="password" class="form-input">
                    </div>
                    <div class="form-group terms">
                       <input type="checkbox">
                        <span>Sign Up For news and updated</span>
                    </div>
                    <div class="form-group terms">
                        <input type="checkbox">
                        <span>I have read and agree to the Private Policy</span>
                    </div>
                      <div class="register-btn mt-5" (click)="signUp()"><button>Register</button></div>
                      <p class="new-cust mt-1">Existing account ?<a routerLink="/login">SIGN IN</a></p>
                  </form> -->
            </div>
        </div>
    </div>

</div>